import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/preload.min.css";
import "../css/icomoon.css";
import "../css/about.min.css";
import "../css/index.min.css";
import default_banner from "../img/golf-image.jpg";
import atv from "../img/atv.png";
import "../scss/custom.scss";
import logo from "../img/loho.png";
import axios from "axios";
import CountdownTimer from "../components/CountdownBanner";

const Home = () => {
  const [data, setData] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [teams, setTeams] = useState([]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    console.log(data);
    if (data.businessName && data.sponsorOption && data.asq) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [data]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await axios.get(
        "https://ihm-golf-tournament-spreadsheet.vercel.app/business",
      );
      if (response.data) {
        setTeams(response.data);
        console.log(response.data);
      } else {
        console.log("No data found.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const submitForm = async () => {
    setSubmitting(true);
    try {
      if (data.asq === "4") {
        let result = await axios.post(
          `https://ihm-golf-tournament-spreadsheet.vercel.app/business`,
          data,
        );
        if (result.status === 200) {
          setShowSuccess(true);
        } else {
          setShowError(
            "There was an error submitting your registration.  Please try again later.",
          );
        }
      } else {
        setShowError(
          "You've incorrectly answered the anti-bot question.  Please refresh and try again.",
        );
      }
    } catch (error) {
      setShowError(
        "There was an error submitting your registration. Please try again later.",
      );
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  const mappedArray = teams.map((innerArray) => {
    return (
      <div className="col-lg-4">
        {innerArray.map((value, index) => {
          if (index !== 1 && index !== 6) {
            if (index === 0) {
              return (
                <p className="title" key={index}>
                  {value}
                </p>
              );
            } else if (index === 2) {
              return (
                <p className="website">
                  <a href={value} key={index}>
                    {value}
                  </a>
                </p>
              );
            }
          }
          return null;
        })}
      </div>
    );
  });

  /* Method that will fix header after a specific scrollable */
  const isSticky = (e) => {
    const header = document.querySelector(".headroom");
    const scrollTop = window.scrollY;
    if (header) {
      scrollTop >= 250
        ? header.classList.add("is-sticky")
        : header.classList.remove("is-sticky");
    }
  };
  return (
    <>
      {/*<Header nav="false" />*/}
      {/* homepage content start */}
      <main>
        <div className="">
          <CountdownTimer />
        </div>
        {/* hero section start */}
        <div className="hero-container">
          <div className="overlay">
            <picture>
              <source data-srcset={default_banner} srcSet={default_banner} />
              <img
                className="lazy"
                data-src={default_banner}
                src={default_banner}
                alt="media"
              />
              <div className="overlay"></div>
            </picture>
          </div>
          <section className="hero section">
            <div
              data-aos="zoom-in"
              className="container container--hero d-lg-flex align-items-center justify-content-center"
            >
              <div className="">
                <img
                  className="banner-logo"
                  src={logo}
                  alt="IHM GOLF TOURNAMENT"
                ></img>
                <h1>
                  <span className="subtitle">Immaculate Heart of Mary</span>
                  <br /> Golf Tournament
                </h1>
                <p>
                  <i className="icon-location"></i> THE PONDS GOLF COURSE
                </p>
                <div className="hero_main-content center">
                  {/*<span className="line"></span> 
                <p className="text">
                  Sign up and pay below
                </p>
                */}
                </div>
                {/*<div className="item-wrapper d-sm-flex flex-wrap flex-lg-nowrap justify-content-center align-items-lg-center">
                <a className="btn theme-element theme-element--accent m-1" type="submit" href="tel:763-434-3686">
                  SIGN UP AND PAY
                </a>
              </div>*/}
              </div>
            </div>
          </section>
        </div>

        <div class="main-content">
          <nav className="breadcrumbs">
            <div className="container">
              <a href="/">Home</a>
              <span className="separator">/</span>
              <span className="current">Become a Sponsor</span>
            </div>
          </nav>
          {/* hero section end */}
          {/* rooms section start */}
          <section className="section">
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <h2>Become a Sponsor</h2>
                  <p>
                    Here at IHMA we strive to provide an excellent educational
                    experience for our students, and to ever improve our
                    community. Thank you for your continued support, your
                    contributions help make it all possible. God bless!
                  </p>
                </div>
                {teams.length > 0 && (
                  <div className="">
                    <h4 className="mb-4">Sponsors confirmed so far:</h4>
                    {teams.length > 0 ? (
                      <div className="sponsors row">{mappedArray}</div>
                    ) : (
                      <div className="pulsating-square"></div>
                    )}
                  </div>
                )}
              </div>
              <hr style={{ width: "80%", margin: "auto", marginTop: "50px" }} />
              <div className="row sponsorship-options">
                <h4 className="mb-3 mt-5">Sponsorship Options</h4>
                <div className="col-lg-6 mt-3">
                  <div className="card">
                    <p className="m-5">
                      <strong>SPONSOR A HOLE - $500</strong>
                      <br />
                      We will place a yard sign with your business name at one
                      of the 18 holes. Your business name will also be featured
                      on our banner, at the gathering area of the club at the
                      tournament.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 mt-3">
                  <div className="card">
                    <p className="m-5">
                      <strong>SPONSOR A GAME - $200</strong>
                      <br />
                      Your contribution will be used to sponsor the prizes for
                      one of our many side games, to be played the day of the
                      tournament.
                      <br />
                      <br />
                    </p>
                  </div>
                </div>

                <p className="mt-5">
                  As a corporate sponsor of either level, you will also be added
                  to our elite vendors list. When members of our community need
                  services in the future, elite vendors will be their first
                  consideration.{" "}
                </p>
                <p>
                  <strong>
                    Deadline for corporate sponsor sign up is{" "}
                    <strong>May 16th</strong>.
                  </strong>
                </p>
              </div>
            </div>
          </section>
          <section className="section dark primary-bg main">
            <div className="block" />
            <div className="container">
              <div className=" align-items-center mb-1">
                <h3 className="max-width" data-aos="fade-right">
                  Sponsorship Request
                </h3>
                <p>
                  <br />
                  <strong>All fields required.</strong>
                </p>
                <div className="contacts_secondary-form" data-aos="fade-left">
                  <div className="contacts" data-aos="fade-left">
                    <div className="contacts_header">
                      <p className="input-grouping">
                        <span>Business Name</span>
                        <div className="field-wrapper mt-2">
                          <input
                            onChange={handleChange}
                            value={data.businessName}
                            className="field required"
                            id="feedbackName"
                            type="text"
                            placeholder="Enter Business Name"
                            name="businessName"
                          />
                        </div>
                      </p>
                      <p className="input-grouping">
                        <span>Business Email</span>
                        <div className="field-wrapper mt-2">
                          <input
                            className="field required"
                            id="feedbackName"
                            type="text"
                            placeholder="Enter Email Address"
                            onChange={handleChange}
                            name="businessEmail"
                            value={data.businessEmail}
                          />
                        </div>
                      </p>
                      <p className="input-grouping">
                        <span>Business Website</span>
                        <div className="field-wrapper mt-2">
                          <input
                            className="field required"
                            id="businessWebsite"
                            type="text"
                            placeholder="yourbusiness.com"
                            onChange={handleChange}
                            name="businessWebsite"
                            value={data.businessWebsite}
                          />
                        </div>
                      </p>
                      <p className="input-grouping">
                        <span>Sponsorship Option</span>
                        <div className="field-wrapper mt-2">
                          <select
                            data={data.sponsorOption}
                            name="sponsorOption"
                            onChange={handleChange}
                          >
                            <option name="sponsorOption" value=""></option>
                            <option
                              name="sponsorOption"
                              value="SPONSOR A HOLE - $500"
                            >
                              SPONSOR A HOLE - $500
                            </option>
                            <option
                              name="sponsorOption"
                              value="SPONSOR A GAME - $200"
                            >
                              SPONSOR A GAME - $200
                            </option>
                          </select>
                        </div>
                      </p>
                      <p className="input-grouping">
                        <p className="mt-5">
                          <strong>Anti-Bot Question</strong>
                        </p>
                        <span>What is 2 + 2?</span>
                        <div className="field-wrapper mt-2">
                          <input
                            className="field required"
                            id="feedbackName"
                            type="text"
                            onChange={handleChange}
                            name="asq"
                            value={data.asq}
                          />
                        </div>
                      </p>
                      {disabled && (
                        <p className="sm-p">
                          Please fill in all fields to submit registration.
                        </p>
                      )}
                      <button
                        disabled={disabled || submitting}
                        onClick={submitForm}
                        className="btn theme-element theme-element--accent mt-4"
                      >
                        {submitting ? (
                          <>
                            <i className="fas fa-spinner fa-spin" />{" "}
                            Submitting...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-share" /> Submit Registration
                          </>
                        )}
                      </button>
                      {showSuccess && (
                        <p className="mt-3" data-aos="fade-up">
                          Your Sponsorship request has been received. Please pay
                          the fee below and we'll contact you shortly.
                        </p>
                      )}
                      {showError && (
                        <p className="mt-3" data-aos="fade-up">
                          {showError}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section location pb-5" data-aos="fade-left">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h3 className="mb-4">Payment</h3>
                  <p className="mt-3">
                    <span>
                      <strong>Pay with Paypal:</strong>
                    </span>
                    <div className="mt-3">
                      <a
                        href="https://www.paypal.com/ncp/payment/FNNRPU8Z9SRU4"
                        className=" theme-element btn"
                      >
                        PAY NOW
                      </a>
                    </div>
                  </p>
                  <p>
                    <strong>Or send payments (cash or check) to:</strong>
                    <br />
                    <br />
                    Immaculate Heart of Mary Academy
                    <br />
                    777 221st. Avenue NW
                    <br />
                    Oak Grove, MN 55011
                  </p>
                  <p>
                    Please make checks payable to: <br />
                    "IHM Academy"
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      {/* homepage content end */}

      {/*<GoogleReviews placeId={placeId} />*/}
      <footer className="footer accent">
        <div className="container">
          <div className="footer_copyright">
            <div className="container">
              <p className="footer_copyright-text">
                <span className="linebreak">
                  Made by Up North Creative
                  <br />
                </span>
                <span className="linebreak">All rights reserved © 2026</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
      {/**/}
    </>
  );
};

export default Home;
